export default __webpack_public_path__ + "static/chat-icon-user2-b96a667e20f0f78c60f27e61eaa0d7a6.png";